module.exports = __webpack_public_path__ + "img/cliff-sides.df22445b.png";